export default __webpack_public_path__ + "static/media/03_Srnec_obecny_PELZ_upr.47d396d5.mp3";